export default __webpack_public_path__ + "9bbe990fcd7aacb3fc3796db5f0e71b0.png";